import React from 'react';
import { Inbox } from 'lucide-react';
import { ILMSButton } from './ILMSButton';
import { cn } from '../utils/cn';

export interface ILMSEmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionHref?: string;
  className?: string;
}

export function ILMSEmptyState({ icon, title, description, actionLabel, onAction, actionHref, className }: ILMSEmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center py-12 px-4', className)}>
      <div className="h-12 w-12 rounded-full bg-surface-muted flex items-center justify-center text-ink-400 mb-3">
        {icon ?? <Inbox className="h-6 w-6" aria-hidden="true" />}
      </div>
      <p className="text-card-title text-ink-700">{title}</p>
      {description && <p className="text-secondary text-ink-500 mt-1 max-w-sm">{description}</p>}
      {actionLabel && (onAction || actionHref) && (
        <div className="mt-4">
          {actionHref ? (
            <ILMSButton size="sm" onClick={() => (window.location.href = actionHref)}>
              {actionLabel}
            </ILMSButton>
          ) : (
            <ILMSButton size="sm" onClick={onAction}>
              {actionLabel}
            </ILMSButton>
          )}
        </div>
      )}
    </div>
  );
}
